import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { generateLoremIpsum } from '@utils/string';

interface BlurredLoremProps {
    lines: number;
}

const BlurredLorem: FC<BlurredLoremProps> = ({ lines }) => {
    const text = generateLoremIpsum(lines);

    return text ? (
        <Box data-test-id="blurred-lorem" sx={{ filter: 'blur(3px)' }}>
            <Typography color="textPrimary" variant="body2">
                {text}
            </Typography>
        </Box>
    ) : null;
};

export default BlurredLorem;
